import { render, staticRenderFns } from "./SortableTable.vue?vue&type=template&id=1ade455d&scoped=true&"
import script from "./SortableTable.vue?vue&type=script&lang=js&"
export * from "./SortableTable.vue?vue&type=script&lang=js&"
import style0 from "./SortableTable.vue?vue&type=style&index=0&id=1ade455d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ade455d",
  null
  
)

component.options.__file = "SortableTable.vue"
export default component.exports